import UIHelper from 'general/helpers/UIHelper';
import useRouter from 'hooks/useRouter';
import FleetDetailView from '../../components/FleetDetailView';

FleetDetailScreen.propTypes = {};

function FleetDetailScreen(props) {
    // MARK: ---- PROPERTIES ----
    const router = useRouter();
    const { isFleetInfo = false } = props;
    const agencyId = router.query?.agencyId;

    return (
        <div>
            {/* breadcrumb */}
            {!isFleetInfo && (
                <div>
                    {UIHelper.buildBreadcrumb([
                        {
                            title: 'Danh sách DNVT',
                            onPress: () => {
                                router.navigate(-1);
                            },
                        },
                        { title: 'Chi tiết DNVT' },
                    ])}
                </div>
            )}
            <div className="my-4">
                <FleetDetailView agencyId={agencyId} isFleetInfo={isFleetInfo} />
            </div>
        </div>
    );
}

export default FleetDetailScreen;
